import React from "react";
import { useNavigate } from "react-router-dom";

const Unauthorized = () => {
    const navigate = useNavigate();

    return (
        <div className="h-screen flex items-center justify-center bg-gray-100 px-4">
            <div className="text-center animate-fadeIn">
                <h1 className="text-5xl font-extrabold text-yellow-500 drop-shadow-md">403</h1>
                <h2 className="text-2xl font-semibold mt-2 text-gray-800">Unauthorized Access</h2>
                <p className="mt-2 text-gray-600">You do not have permission to access this page.</p>

                <button
                    onClick={() => navigate("/login")}
                    className="mt-6 px-6 py-3 bg-yellow-500 hover:bg-yellow-600 text-white font-semibold rounded-full shadow-md transition-transform duration-300 hover:-translate-y-1 hover:scale-105"
                >
                    Go to Login
                </button>
            </div>
        </div>
    );
};

export default Unauthorized;
